<template>
    <div v-if="localItem && (localItem.StockStatus != 'PRE' && localItem.StockStatus != 'PRE2' && localItem.StockStatus != 'NO') " class="c-product-size-scope" :class="{'pre-order-stock': showStockForPreOrder}">
        <div v-if="!isAdmin" class="c-product-size" :class="{'is-valid' : isValid, 'is-invalid': isInvalid, 'is-disabled': isDisabled || localLoading}">
            <v-input v-if="localItem"  :disabled="isDisabled" :horizontal="false" type="number" :min="0" :name="`${_uid}-product-size`" input-size="small" :value="item.Amount" v-model.number="localItem.Amount" @change="updateItem">
                <span slot="label" class="u-text-align-center u-block u-margin-bottom-tiny">{{item.Size}}</span>
            </v-input>

            <!-- The amount in the basket -->
            <div v-if="localItem && typeof localItem.BasketAmount !== 'undefined'" 
                class="c-product-size__stock u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny" 
                :class="{'is-valid' : isValid, 'is-invalid': isInvalid}">
                <svgicon name="shopping-cart" width="1em" height="1em" class="u-svg-color-apha-base"></svgicon>
                <span>{{ localItem.BasketAmount }}</span>
            </div>

            <!-- The stock available -->
            <div v-if="localItem && typeof localItem.Stock !== 'undefined' || !localItem"
                    class="c-product-size__stock u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny"
                    :class="{'is-valid' : isValid, 'is-invalid': isInvalid}">

                <template v-if="localItem && localItem.Stock && localItem.Stock > 0">
                    <svgicon name="check" width=".8em" height=".8em" class="u-svg-color-success-base"></svgicon>
                    <span>Stock: {{ localItem.Stock }}</span>
                </template>
                <template v-else-if="localItem">
                    <svgicon name="cross" width=".6em" height=".6em" class="u-svg-color-alpha-base"></svgicon>
                    <span>{{ localItem.StockIndication }}</span>
                </template>

                <span v-if="localItem.NextStockDelivery" v-tooltip="{ content: getFormattedNextDeliveryDate, classes: 'information' }">
                    <svgicon name="info" width="1em" height="1em" class="u-svg-color-info-base"></svgicon>
                </span>
            </div>
            <div class="c-product-size__stock u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny" v-if="showStockForPreOrder">
                <span>Stock: {{ localItem.AmountInStock }}</span>
            </div>
            <div class="c-product-size__stock u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny" v-if="showStockForPreOrder">
                <span>Future stock: {{ localItem.FutureAvailableStock - localItem.AmountInStock }}</span>
            </div>
        </div>
        <div v-else>
            <v-product-size-toggle :item.sync="item"></v-product-size-toggle>
        </div>
    </div>
    <div v-else class="c-product-size-scope--empty"></div>
</template>

    <script>
        import debounce from 'lodash/debounce'
        import VInput from '@/components/form/Input'
        import VProductSizeToggle from '@/components/product/widgets/productSizeToggle'

        export default {
            components: {
                VInput,
                VProductSizeToggle
            },
            props: {
                item: Object,
                isAdmin: Boolean,
                disabled: { type: Boolean, default: false },
                showStockForPreOrder: { type: Boolean, default: false }
            },
            data() {
                return {
                    localItem: this.item,
                    localLoading: false,
                    updateProductVariant: debounce(function () {
                      this.$emit('loaded', {});
                      this.localLoading = true;

                      this.$store.dispatch('updatePreOrderProductVariant', {
                        preOrderId: this.$route.params.id,
                        productVariantId: this.localItem.Id,
                        body: {
                          Id: this.localItem.Id,
                          Amount: this.localItem.Amount
                        }
                      }).then(() => {
                        this.$emit('loaded', { isLoaded: true });
                        this.localLoading = false;

                        this.$store.dispatch('getPreOrderTotalsById', this.$route.params.id);
                      });
                    }, 500)
                }
            },
            computed: {
                isValid() {
                    if (this.localItem && typeof this.localItem.Stock !== 'undefined' && this.localItem.Amount > 0) {
                        if(this.localItem.StockStatus == 'STOCK'
                        || this.localItem.StockStatus == 'STOCK2'
                        || this.localItem.StockStatus == 'OPB'
                        || this.localItem.StockStatus == 'NOS'
                        || this.localItem.StockStatus == 'OUT') {
                            return true;
                        } else {
                            return this.localItem.Amount <= this.localItem.Stock;
                        }
                    }
                },
                isInvalid(){
                    if (this.localItem &&typeof this.localItem.Stock !== 'undefined') {
                        if(this.localItem.StockStatus == 'ZVS' || this.localItem.StockStatus == 'ZVS2') {
                            return this.localItem.Amount > this.localItem.Stock;
                        } else {
                            return false;
                        }
                    }
                },
                isDisabled(){
                    if(this.disabled) return this.disabled;

                    if (typeof this.localItem.Stock !== 'undefined') {
                        return this.localItem
                        && (this.localItem.StockStatus == 'PRE'
                            || this.localItem.StockStatus == 'PRE2'
                            || this.localItem.StockStatus == 'NO'
                            || ((this.localItem.StockStatus == 'ZVS' || this.localItem.StockStatus == 'ZVS2') && !this.localItem.Stock > 0));
                    } else {
                        return !(this.localItem.IsEnabled && this.localItem.IsAvailable);
                    }
                },
                isCustomer(){
                    return !this.$store.getters.userInfo.impersonated &&
                       (this.$store.getters.userInfo.role == "Klant" || this.$store.getters.userInfo.role == "PersoneelKlant" || this.$store.getters.userInfo.role == "MarketingKlant");
                },
                getFormattedNextDeliveryDate(){
                    return this.$t('customer.shop.detail.new_stock_available', {date: this.$moment(this.localItem.NextStockDelivery).format('DD-MM-YYYY')});
                }
            },
            watch: {
              'localItem.Amount'() {
                  if (typeof this.localItem.Amount === 'string') {
                    this.localItem.Amount = 0;
                  }
              }
            },
            methods: {
                updateItem() {
                    this.updateProductVariant();
                    this.$emit('update:item', this.localItem);
                }
            }
        }
    </script>

    <style lang="scss" scoped>
        @import "~@/assets/scss/private";

        .c-product-size-scope {
            margin-right: 10px;
            margin-bottom: 10px;

            .sizes-wrapper & {
                width: 15%;
            }

            &:last-child { margin-right: 0; }

            &--empty {
                width: 15%;
                margin-right: 10px;
            }
        }

        .c-product-size {
            border: 1px dashed palette(color-neutral, light);
            padding: em($global-spacing-unit-tiny);
            height: 125px;

            &.is-valid{
                border-color: $color-success;
                border-style: solid;
                background-color: rgba($color-success, .05);
            }

            &.is-invalid{
                border-color: $color-error;
                border-style: solid;
                background-color: rgba($color-error, .05);
            }

            &.is-disabled{
                opacity:.5;
            }
        }

        .c-product-size__stock{
            border: 1px solid transparent;
            font-size: 11px !important;
            &.is-invalid{
                border: 1px solid $color-error;
            }
        }

        .pre-order-stock {
            height: 160px;
        }
    </style>

    <style lang="scss">

        @import "~@/assets/scss/private";

        .c-product-size {
            max-width: 110px;
            min-width: 80px;
            label {
                margin-bottom: em($global-spacing-unit-tiny);
            }
        }

        .sizes-wrapper .c-product-size-toggle {
            width: 100% !important;
            height: 125px !important;
        }
    </style>




// WEBPACK FOOTER //
// src/components/product/widgets/productPantsSizeInput.vue